export default __webpack_public_path__ + "static/Epson-story-PDF-288ab20fcfd32a8782c5e8f7a8da2f37.pdf";